import { Badge, BadgePosition, BadgeType } from '@dreryk/react-components';

type ConsentTemplateActionBadgeProps = {
   readonly numberOfDrafts: number;
   readonly children: JSX.Element;
};

export const ConsentTemplateActionBadge = (props: ConsentTemplateActionBadgeProps): JSX.Element => {
   return (
      <Badge
         type={BadgeType.WARNING}
         count={props.numberOfDrafts}
         position={BadgePosition.TOP_RIGHT}
         testId={'availableDrafts'}
         visible={Boolean(props.numberOfDrafts)}
         compact
      >
         {props.children}
      </Badge>
   );
};
